// extracted by mini-css-extract-plugin
export default {"legalTextBanner":"legaltext-banner_legalTextBanner__krIpV","legalTextContent":"legaltext-banner_legalTextContent__PqsIg"};